import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import {Input, Typography} from "@material-tailwind/react";

const FromToNumberField = ({className, fromNumber, setFromNumber, toNumber, setToNumber, label}) => {

  const [primaryFrom, setPrimaryFrom] = useState(null);
  const [primaryTo, setPrimaryTo] = useState(null);

  const [updateFrom, setUpdateFrom] = useState(false);
  const [updateTo, setUpdateTo] = useState(false);

  useEffect(() => {
    setFromNumber(primaryFrom)
  }, [updateFrom]);

  useEffect(() => {
    setToNumber(primaryTo)
  }, [updateTo]);

  return (
    <div className="flex flex-col gap-x-2 w-full mb-4 md:flex-row">
      <div className="flex flex-row w-full mb-4">
        <Typography className="w-1/2 mt-3 md:w-1/3">
          {`${label} از:`}
        </Typography>
        <Input
          variant="standard"
          value={primaryFrom}
          onChange={e => setPrimaryFrom(e.target.value)}
          onBlur={() => {
            setUpdateFrom(!updateFrom)
          }}
          type="number"
          min={0}
          step={500000}
        />
      </div>

      <div className=" flex flex-row mr-4 w-full">
        <Typography className="w-1/2 mt-3 md:w-1/3">
          تا:
        </Typography>
        <Input
          variant="standard"
          value={primaryTo}
          onChange={e => setPrimaryTo(e.target.value)}
          onBlur={() => {
            setUpdateTo(!updateTo)
          }}
          type="number"
          min={0}
          step={500000}
        />
      </div>
    </div>
  )
    ;
};

export default FromToNumberField;
